import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual"
import ProgressiveImage from "react-progressive-image-loading";
import Rating from "react-rating";
import {showToast} from "../../helpers/magic";
import {withRouter} from "react-router-dom";

class OfferCard extends Component {
    componentWillReceiveProps(nextProps, nextContext) {
        this.discount = nextProps.offer ? Math.round((nextProps.offer.price / nextProps.offer.old_price) * 100) : null;
    }
    state = {
        copied: false,
    };

    handleCopyBtn = (e) => {
        e.preventDefault();
        this.setState({copied: true});
        showToast(this.props.translate('offer_link_copied_successfully'), "green")
    };

    showTitle = (offer) => {
        let copyOfferTitle = document.getElementById("copy-offer-title" + offer.id);
        copyOfferTitle.style.display = "block";
    };
    hideTitle = (offer) => {
        let copyOfferTitle = document.getElementById("copy-offer-title" + offer.id);
        copyOfferTitle.style.display = "none";
    };

    render() {
        const {offer} = this.props;
        this.discount = offer ? Math.round((offer.price / offer.old_price) * 100) : null;

        return (
            <div>
                <div className="offer-card shadow-4d relative cursor-pointer">
                    <div className="offer-image">
                        <ProgressiveImage
                            preview="/images/offer-image-placeholder.png"
                            src={offer.image}
                            render={(src, style) => <img alt="head" src={src} style={style}/>}
                        />
                    </div>
                    <div className="offer-details">
                        <div className="offer-over relative">
                            <div className="offer-header">
                                <div className="offer-doc-details">
                                    <img className="offer-avatar pull-left"
                                         src={offer.doctor.image} alt="profile"/>
                                    <div className="doc-name-rate">
                                        <p className="offer-doctor-name bolder">{offer.doctor_name}</p>
                                        <Rating
                                            direction={this.props.language === 'ar' ? "rtl" : "ltr"}
                                            initialRating={offer.doctor.rate}
                                            readonly
                                            emptySymbol="fa fa-star-o font-20 empty-star"
                                            fullSymbol="fa fa-star font-20 full-star"
                                        />
                                    </div>
                                </div>
                                {/*     <div onMouseOver={() => this.showTitle(offer)} onMouseOut={() => this.hideTitle(offer)} className="offer-option" onClick={(e) => this.handleCopyBtn(e)}>
                                    <CopyToClipboard text={window.location.origin + "/offer/" + offer.id}>
                                        <div className="cursor-pointer">
                                            <i className="fas fa-copy offer-icon"></i>
                                        </div>
                                    </CopyToClipboard>
                                    <p className="copy-offer-title" id={"copy-offer-title" + offer.id}>{this.props.translate('copy_offer_link')}</p>
                                </div>*/}
                            </div>
                            <div className="offer-info">
                                {
                                    this.discount && this.discount !== "UNDEFINED" ?
                                        <p className="discount-off">{this.discount + " " + "%"+ " " +this.props.translate('off')}</p>
                                        : null
                                }
                                <div style={{padding: '0 12px'}}>
                                    <div className="offer-info-name">
                                         <span
                                             className={offer.is_featured === 1 ? "offer-featured capitalized" : "capitalized"}>{offer.is_featured === 1 ? this.props.translate('ad') : ""}</span>
                                        <span className="font-20 offer-name bolder mb-0">{offer.name}</span>
                                    </div>
                                    <div className="offer-booked-details">
                                        <div className="offer-booked">
                                            <p className="name">
                                                {/*<img className="icon" src="/images/doctor-name.png" alt=""/>*/}
                                                {offer.users_booked + " " + this.props.translate('users_booked')}
                                            </p>
                                            <p className="expired capitalized">
                                                {offer.expiry_date === 0 ?
                                                    this.props.translate('expires_today')
                                                : this.props.translate('expires_on') + " " + offer.expiry_date + " " + this.props.translate('days')}
                                            </p>
                                        </div>
                                        <div className="offer-discount">
                                            {/*<p className="bolder font-15">{offer.price +
                                            " " + (offer.price_type === 0 ? this.props.translate("currency") : "%" + this.props.translate("discount"))}</p>*/}
                                            <strike>{offer.old_price + " " + this.props.translate("currency")}</strike>
                                            <p className="bolder font-15">{offer.price + " " + this.props.translate("currency")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="offer-discount-overlay"></div>
                            <div className="offer-info-overlay"></div>*/}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslate(withRouter(OfferCard));